import { bounds } from './bounds'
import { overflow } from './overflow'
import { layout } from './layout'
import { border } from './border'
import { styleHandler } from './style-handler'
import { backgroundColor } from './background-color'

export default [
    styleHandler,
    layout,
    bounds,
    backgroundColor,
    overflow,
    border,
]
